"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconQR = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Styled = styled_components_1.default.button `
	appearance: none;
	background: transparent;
	cursor: pointer;
	border-style: none;
	transition: color 0.3s ${(p) => p.theme.easing};
	color: ${(p) => p.theme.palette.text.secondary || p.theme.palette.text.primary};
	width: 36px;
	height: 40px;
	display: inline-block;
	padding: 10px 4px 8px;
	i {
		font-size: 28px;
	}

	&:hover {
		color: ${(p) => p.theme.palette.accent.text};
	}

	.qrcode-bg {
		height: 200px;
		width: 200px;
		background-size: contain;
		position: absolute;
		z-index: 3;
		border-radius: 5px;
	}
`;
const IconQR = ({ id, qrCode }) => {
    const [showImage, setShowImage] = (0, react_1.useState)(false);
    const onClick = (0, react_1.useCallback)(() => {
        setShowImage(!showImage);
    }, [showImage, setShowImage]);
    if (!qrCode)
        return null;
    const style = {
        backgroundImage: `url(${qrCode})`,
    };
    return (react_1.default.createElement(Styled, { className: "qr-opener", onClick: onClick, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, tabIndex: -1 },
        react_1.default.createElement("i", { className: `eg-footer-icon-${id}` }),
        showImage ? react_1.default.createElement("div", { className: `image-container qrcode-bg`, style: style }) : ""));
};
exports.IconQR = IconQR;
//# sourceMappingURL=IconQR.atom.js.map